<div *ngIf="patient">
  <form #patientForm="ngForm">

    <!-- DADOS GERAIS DO PACIENTE **************************************** -->
    <div class="form-row">

      <div class="form-group col-7">
        <label for="name">Nome*</label>
        <input class="form-control" type="text" id="name" name="name" #name="ngModel" [(ngModel)]="patient.name" required minlength="10" maxlength="250" />
        <div *ngIf="name.invalid && (name.dirty || name.touched)" class="text-danger">
          <small>
            <div *ngIf="name.errors.required">Nome é obrigatório</div>
            <div *ngIf="name.errors.minlength">Nome deve ter no mínimo 10 caracteres</div>
            <div *ngIf="name.errors.maxlength">Nome deve ter no máximo 250 caracteres</div>
          </small>
        </div>
      </div>

      <div class="form-group col-5">
        <label for="email">E-mail</label>
        <input class="form-control" type="email" id="email" name="email" #email="ngModel" [(ngModel)]="patient.email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" />
        <div *ngIf="email.invalid && (email.dirty || email.touched)" class="text-danger">
          <small>
            <!-- <div *ngIf="email.errors.required">E-mail é obrigatório</div> -->
            <div *ngIf="email.errors.pattern">E-mail inválido</div>
          </small>
        </div>
      </div>
    </div>

   <div class="form-row">
       <div class="form-group col-12 col-md-7">
        <label for="occupation">Profissão</label>
        <input class="form-control" type="text" id="occupation" name="occupation" #occupation="ngModel" [(ngModel)]="patient.occupation" />
      </div>

      <div class="form-group col-6 col-md-3">
        <label for="gender">Gênero*</label>
        <select id="gender" class="form-control" name="gender" #gender="ngModel" [(ngModel)]="patient.gender" required>
          <option value="1" [selected]="patient.gender == 1">Feminino</option>
          <option value="2" [selected]="patient.gender == 2">Masculino</option>
        </select>
        <div *ngIf="gender.invalid && (gender.dirty || gender.touched)" class="text-danger">
          <small><div *ngIf="gender.errors.required">Gênero é obrigatório</div></small>
        </div>
      </div>

      <div class="form-group col-6 col-md-2">
        <label for="dob">Nascimento*</label>
        <my-date-picker (dateChanged)="onDobChanged($event)" id="dob" name="dob" [options]="myDpOptions" [ngModel]="dob" required></my-date-picker>
        <div *ngIf="dob.invalid && (dob.dirty || dob.touched)" class="text-danger">
          <small>
            <div *ngIf="dob.errors.required">Nascimento é obrigatório</div>
          </small>
        </div>
      </div>

    </div>

    <!-- FILIAÇÃO ************************************************************* -->
    <div class="card">
      <div class="card-header col-12">Filiação</div>
      <div class="card-body">

        <div class="form-row">
          <div class="col-9">
            <label for="mother_name">Mãe*</label>
            <input type="text" id="mother_name" class="form-control" name="mother_name" #mother_name="ngModel" [(ngModel)]="patient.mother_name" required minlength="10" maxlength="250" />
            <div *ngIf="mother_name.invalid && (mother_name.dirty || mother_name.touched)" class="text-danger">
              <small>
                <div *ngIf="mother_name.errors.required">Mãe é obrigatório</div>
                <div *ngIf="mother_name.errors.minlength">Mãe deve ter no mínimo 10 caracteres</div>
                <div *ngIf="mother_name.errors.maxlength">Mãe deve ter no máximo 250 caracteres</div>
              </small>
            </div>
          </div>
          <div class="col-3">
            <label for="mother_phone">Telefone</label>
            <input id="mother_phone" name="mother_phone" type="text" class="form-control" #mother_phone="ngModel" [(ngModel)]="patient.mother_phone" maxlength="14" 
            mask="(00)00000-0009" pattern="^([1-9]{2}[9][0-9]{8})|([1-9]{2}[1-8][0-9]{7})$" />
            <div *ngIf="mother_phone.invalid && (mother_phone.dirty || mother_phone.touched)" class="text-danger">
              <small>
                <div *ngIf="mother_phone.errors.pattern">Telefone inválido</div>
              </small>
            </div>
          </div>
        </div>

        <div class="form-row mt-2">
          <div class="col-9">
            <label for="father_name">Pai</label>
            <input id="father_name" class="form-control" type="text" name="father_name" #father_name="ngModel" [(ngModel)]="patient.father_name" minlength="10" maxlength="250" />
            <div *ngIf="father_name.invalid && (father_name.dirty || father_name.touched)" class="text-danger">
              <small>
                <div *ngIf="father_name.errors.minlength">Pai deve ter no mínimo 10 caracteres</div>
                <div *ngIf="father_name.errors.maxlength">Pai deve ter no máximo 250 caracteres</div>
              </small>
            </div>
          </div>
          <div class="col-3">
            <label for="father_phone">Telefone</label>
            <input id="father_phone" class="form-control" type="text" name="father_phone" #father_phone="ngModel" [(ngModel)]="patient.father_phone" maxlength="14" 
            mask="(00)00000-0009" pattern="^([1-9]{2}[9][0-9]{8})|([1-9]{2}[1-8][0-9]{7})$" />
            <div *ngIf="father_phone.invalid && (father_phone.dirty || father_phone.touched)" class="text-danger">
              <small>
                <div *ngIf="father_phone.errors.pattern">Telefone inválido</div>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ENDEREÇO ************************************************************ -->
    <div class="card mt-3">
      <div class="card-header col-12">Endereço</div>
      <div class="card-body">
        <div class="form-group">
          <label for="address">Logradouro*</label>
          <input id="address" type="text" class="form-control" name="address" #address="ngModel" [(ngModel)]="patient.address" required minlength="5" maxlength="250" />
          <div *ngIf="address.invalid && (address.dirty || address.touched)" class="text-danger">
            <small>
              <div *ngIf="address.errors.required">Logradouro é obrigatório</div>
              <div *ngIf="address.errors.minlength">Logradouro deve ter no mínimo 5 caracteres</div>
              <div *ngIf="address.errors.maxlength">Logradouro deve ter no máximo 250 caracteres</div>
            </small>
          </div>
        </div>
        <div class="form-row">
          <div class="col-6">
            <label for="city">Cidade*</label>
            <input id="city" type="text" class="form-control" name="city" #city="ngModel" [(ngModel)]="patient.city" required minlength="5" maxlength="200" />
            <div *ngIf="city.invalid && (city.dirty || city.touched)" class="text-danger">
              <small>
                <div *ngIf="city.errors.required">Cidade é obrigatória</div>
                <div *ngIf="city.errors.minlength">Cidade deve ter no mínimo 5 caracteres</div>
                <div *ngIf="city.errors.maxlength">Cidade deve ter no máximo 200 caracteres</div>
              </small>
            </div>
          </div>

          <div class="form-group col-2">
            <label for="state">Estado*</label>
            <select id="state" class="form-control" name="state" #state="ngModel" [(ngModel)]="patient.state" required>
              <option value="AC" [selected]="patient.state == AC">AC</option>
              <option value="AL" [selected]="patient.state == AL">AL</option>
              <option value="AP" [selected]="patient.state == AP">AP</option>
              <option value="AM" [selected]="patient.state == AM">AM</option>
              <option value="BA" [selected]="patient.state == BA">BA</option>
              <option value="CE" [selected]="patient.state == CE">CE</option>
              <option value="DF" [selected]="patient.state == DF">DF</option>
              <option value="ES" [selected]="patient.state == ES">ES</option>
              <option value="GO" [selected]="patient.state == GO">GO</option>
              <option value="MA" [selected]="patient.state == MA">MA</option>
              <option value="MT" [selected]="patient.state == MT">MT</option>
              <option value="MS" [selected]="patient.state == MS">MS</option>
              <option value="MG" [selected]="patient.state == MG">MG</option>
              <option value="PA" [selected]="patient.state == PA">PA</option>
              <option value="PB" [selected]="patient.state == PB">PB</option>
              <option value="PR" [selected]="patient.state == PR">PR</option>
              <option value="PE" [selected]="patient.state == PE">PE</option>
              <option value="PI" [selected]="patient.state == PI">PI</option>
              <option value="RJ" [selected]="patient.state == RJ">RJ</option>
              <option value="RN" [selected]="patient.state == RN">RN</option>
              <option value="RS" [selected]="patient.state == RS">RS</option>
              <option value="RO" [selected]="patient.state == RO">RO</option>
              <option value="RR" [selected]="patient.state == RR">RR</option>
              <option value="SC" [selected]="patient.state == SC">SC</option>
              <option value="SP" [selected]="patient.state == SP">SP</option>
              <option value="SE" [selected]="patient.state == SE">SE</option>
              <option value="TO" [selected]="patient.state == TO">TO</option>
            </select>
            <div *ngIf="state.invalid && (state.dirty || state.touched)" class="text-danger">
              <small>
                <div *ngIf="state.errors.required">Estado é obrigatório</div>
                <div *ngIf="state.errors.pattern">Estado inválido</div>
              </small>
            </div>
          </div>

          <div class="col-4">
            <label for="zip">CEP*</label>
            <input id="zip" type="text" class="form-control" name="zip" #zip="ngModel" [(ngModel)]="patient.zip" required maxlength="9" mask="00000-000" pattern="^([0-9]{8})$" />
            <div *ngIf="zip.invalid && (zip.dirty || zip.touched)" class="text-danger">
              <small>
                <div *ngIf="zip.errors.required">CEP é obrigatório</div>
                <div *ngIf="zip.errors.pattern">CEP inválido</div>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TELEFONES ************************************************************ -->
    <div class="card mt-3">
      <div class="card-header col-12">Telefones</div>
      <div class="card-body">
        <div class="form-row">
          <div class="col-6">
            <label for="homephone">Residencial</label>
            <input id="homephone" type="text" class="form-control" name="homephone" #homephone="ngModel" 
                  [(ngModel)]="patient.homephone" maxlength="14" mask="{{ homephoneMask }}" (keyup)="onHomephoneChanged(homephone.value)"
                  pattern="^([1-9]{2}[9][0-9]{8})|([1-9]{2}[1-8][0-9]{7})$" />
            <div *ngIf="homephone.invalid && (homephone.dirty || homephone.touched)" class="text-danger">
              <small>
                <!-- <div *ngIf="homephone.errors.required">Tel Residencial é obrigatório</div> -->
                <div *ngIf="homephone.errors.pattern">Tel Residencial inválido</div>
              </small>
            </div>
          </div>
          <div class="col-6">
            <label for="cellphone">Celular*</label>
            <input id="cellphone" type="text" class="form-control" name="cellphone" #cellphone="ngModel" 
                  [(ngModel)]="patient.cellphone" required maxlength="14" mask="{{ cellphoneMask }}" (keyup)="onCellphoneChanged(cellphone.value)"
                  pattern="^([1-9]{2}[9][0-9]{8})|([1-9]{2}[1-8][0-9]{7})$" />
            <div *ngIf="cellphone.invalid && (cellphone.dirty || cellphone.touched)" class="text-danger">
              <small>
                <div *ngIf="cellphone.errors.required">Celular é obrigatório</div>
                <div *ngIf="cellphone.errors.pattern">Celular inválido</div>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>


  <div class="float-right mt-3 mb-2">
    <button class="btn btn-secondary mr-1" (click)="cancel()">Cancelar</button>
    <button class="btn btn-primary" [disabled]="!patientForm.form.valid" (click)="save()">Salvar</button>
  </div>


  </form>
</div>
